module.exports = __webpack_public_path__ + "img/cicon2.ea130631.png";